<div
  class="arrow"
  [class]="direction + '-direction'"
  [ngStyle]="{
    height: size + 'px',
    width: size + 'px',
    'border-top': weight + 'px' + ' solid ' + color,
    'border-right': weight + 'px' + ' solid ' + color,
  }"
></div>
